import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyA097A6wVgnoSFLo2jLV80PPsGegClx2qo",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "sitescope-8c881.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "sitescope-8c881",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "sitescope-8c881.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "312769450155",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:312769450155:web:3b74c83a4e6f604549a7ee",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-LKR0FDRES8",
};

const app = initializeApp(firebaseConfig);
export { app };

// Initialize Analytics only in secure browser contexts
if (typeof window !== "undefined" && window.isSecureContext) {
  isAnalyticsSupported().then((ok) => { if (ok) getAnalytics(app); }).catch(() => {});
}

async function getSW() {
  if (!("serviceWorker" in navigator)) return null;
  return await navigator.serviceWorker.register("/firebase-messaging-sw.js");
}

export async function requestPermissionAndToken() {
  try {
    const supported = await isSupported();
    if (!supported) {
      console.log("FCM not supported in this browser");
      return null;
    }

    // Request notification permission
    if (Notification.permission === 'default') {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.log("Notification permission denied");
        return null;
      }
    } else if (Notification.permission === 'denied') {
      console.log("Notification permission denied");
      return null;
    }

    const swReg = await getSW();
    const messaging = getMessaging(app);

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: swReg || undefined,
    });
    
    if (token) {
      console.log("✅ FCM token generated successfully");
      
      // Save token to backend
      try {
        const response = await fetch(`${(process.env.REACT_APP_API_BASE || 'http://localhost:4000').replace(/\/$/, '')}/save-token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({ token })
        });
        
        if (response.ok) {
          console.log("✅ FCM token saved to backend");
        } else {
          console.error("❌ Failed to save FCM token to backend");
        }
      } catch (error) {
        console.error("❌ Error saving FCM token:", error);
      }
    }
    
    return token || null;
  } catch (err) {
    console.error("FCM permission/token error:", err);
    return null;
  }
}

export function onForegroundMessage(cb) {
  isSupported().then((ok) => {
    if (!ok) return;
    const messaging = getMessaging(app);
    onMessage(messaging, (payload) => cb?.(payload));
  });
}
